import { AuthService as authService } from "@common/auth.service";
import { config } from "aws-sdk";
import { debug } from "util";
import { Constants } from "@constants/shared";

class LoginController implements angular.IOnInit {
  public isLoading: boolean = false;
  public showPassword: boolean = false;
  public loginFailed: boolean;
  public changePassword: boolean = false;
  public forgotPassword: boolean = false;

  public username: string;
  public password: string;
  public newPassword: string;
  public newPasswordConfirmation: string;
  public passwordValidations: any;
  public verificationCode: any;
  public failedToVerify = false;

  public changePasswordForm: any;
  public reLogin: boolean = false;
  public innerWidth: any;

  private cognitoUser: any;

  /** @ngInject */
  constructor(
    private authService: authService,
    private $mdDialog: angular.material.IDialogService,
    private $timeout: angular.ITimeoutService
  ) {}

  $onInit(): void {
    this.$timeout(function () {}, 2200);

    this.passwordValidations = {
      notEqual: false,
    };
    this.changePasswordForm = {};
    let innerWidth = window.innerWidth;
    if (innerWidth <= 1200) {
      console.log(innerWidth);
      this.$mdDialog
        .show(
          this.$mdDialog
            .confirm()
            .clickOutsideToClose(true)
            .title("Info")
            .textContent(
              "It appears that you are using a mobile device, would you like to use our mobile app?"
            )
            .ok("Ok")
            .cancel("Cancel")
        )
        .then((result) => {
          if (result) {
            window.location.href = Constants.getMobileWebsite();
          }
        });
    }
  }

  login = () => {
    if (this.username != undefined) {
      this.isLoading = true;
      this.loginFailed = false;
      this.username = this.username.toLowerCase();
      this.authService
        .login(this.username, this.password, this.reLogin)
        .then(
          (response: any) => {
            if (response.message == "newPasswordRequired") {
              this.changePassword = true;
              this.cognitoUser = response.cognitoUser;
              this.isLoading = false;
              return;
            }
            const listOfRoles = this.authService.getUserRoles();
            if (
              (listOfRoles === undefined || listOfRoles === null) &&
              response.message === "authenticated"
            ) {
              this.isLoading = false;
              this.$mdDialog.show(
                this.$mdDialog
                  .alert()
                  .clickOutsideToClose(true)
                  .title("Error")
                  .textContent(
                    "Could NOT find roles linked to you. Please contact your system administrator."
                  )
                  .ok("Ok")
              );
            }
            // On successful authentication, keep isLoading = true so the
            // progress bar continues until the page transition completes.
          },
          (errResp) => {
            this.isLoading = false;
            this.loginFailed = true;
            this.$mdDialog.show(
              this.$mdDialog
                .alert()
                .clickOutsideToClose(true)
                .title("Error")
                .textContent(
                  "Please ensure that you entered the correct email and password."
                )
                .ok("Ok")
            );
          }
        );
    }
  };

  forgotPasswordLink = () => {
    this.failedToVerify = false;
    this.forgotPassword = true;
    if (this.username !== undefined) {
      this.forgotPasswordReset();
    } else {
      this.$mdDialog.show(
        this.$mdDialog
          .alert()
          .clickOutsideToClose(true)
          .title("Info")
          .textContent("Please supply your email address!")
          .ok("Ok")
      );
    }
  };

  resetPassword = () => {
    this.changePassword = true;
    this.isLoading = true;
    this.authService
      .completeNewPasswordChallenge(
        this.cognitoUser,
        this.newPasswordConfirmation,
        this.forgotPassword,
        this.verificationCode,
        this.reLogin
      )
      .then(
        (response: any) => {
          this.changePassword = false;
          this.forgotPassword = false;
          this.$mdDialog.show(
            this.$mdDialog
              .alert()
              .clickOutsideToClose(true)
              .title("Info")
              .textContent(
                "Your password has been succesfully reset. You may login."
              )
              .ok("Ok")
          );
        },
        (errResp: string) => {
          const validationParts = errResp.split(":");
          let alertConfig = this.$mdDialog.alert().ok("Ok");
          if (validationParts.length > 1) {
            alertConfig = alertConfig
              .title("Password Validation")
              .textContent(validationParts[1]);
          } else if (this.forgotPassword) {
            alertConfig = alertConfig
              .clickOutsideToClose(true)
              .title("Info")
              .textContent(
                "Please make sure you put the correct verification code or contact admin."
              );
          }

          this.failedToVerify = true;
          this.$mdDialog.show(alertConfig);
        }
      )
      .finally(() => (this.isLoading = false));
  };

  validatePasswords = () => {
    this.passwordValidations.noMatch = false;
    this.passwordValidations.invalidLength = false;
    this.changePasswordForm.$invalid = false;
    this.changePasswordForm.$valid = true;
    if (
      this.newPasswordConfirmation === "" ||
      this.newPasswordConfirmation === null ||
      this.newPasswordConfirmation === undefined
    ) {
      this.changePasswordForm.$invalid = true;
      this.changePasswordForm.$valid = false;
    }
    if (this.newPassword !== this.newPasswordConfirmation) {
      this.passwordValidations.noMatch = true;
      this.changePasswordForm.$invalid = true;
      this.changePasswordForm.$valid = false;
    }
    if (
      this.newPasswordConfirmation != null &&
      this.newPasswordConfirmation.length < 8
    ) {
      this.passwordValidations.invalidLength = true;
      this.changePasswordForm.$invalid = true;
      this.changePasswordForm.$valid = false;
    }
  };

  forgotPasswordReset = () => {
    this.isLoading = true;
    this.changePassword = true;
    this.username = this.username.toLowerCase();
    this.authService
      .forgotPassword(this.username)
      .then(
        (response: any) =>
          this.$mdDialog
            .alert()
            .clickOutsideToClose(true)
            .title("Info")
            .textContent(
              "Please make sure your email address is correct.\r\n A Verification code has been sent to your email!"
            )
            .ok("Ok"),
        (errResp) =>
          this.$mdDialog
            .alert()
            .clickOutsideToClose(true)
            .title("Error")
            .textContent("Please make sure your email address is correct.")
            .ok("Ok")
      )
      .then((config) => this.$mdDialog.show(config))
      .finally(() => (this.isLoading = false));
  };

  confirmForgotPassword = () => {
    this.authService.confirmForgotPassword(
      this.verificationCode,
      this.newPassword
    );
  };

  cancelPasswordReset() {
    this.forgotPassword = false;
    this.changePassword = false;
    this.cognitoUser = null;
    this.verificationCode = null;
    this.newPassword = null;
    this.newPasswordConfirmation = null;
  }
}

export const login: angular.IComponentOptions = {
  template: require("./login.html"),
  controller: LoginController,
};



// WEBPACK FOOTER //
// ./src/app/login/login.controller.ts